// src/features/medicine-inventory/components/patient/PrescriptionSelector.jsx
import React, { useState, useEffect } from 'react';
import { FaPrescription, FaCalendar, FaUserMd, FaPills } from 'react-icons/fa';
import api from '../../services/api';
import { formatDate } from '../../utils/helpers';

const PrescriptionSelector = ({ patientId, visitId, onSelectPrescription, selectedPrescription }) => {
  const [prescriptions, setPrescriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (patientId) {
      loadPrescriptions();
    } else {
      setPrescriptions([]);
    }
  }, [patientId, visitId]);

  const loadPrescriptions = async () => {
    setIsLoading(true);
    try {
      let response;
      if (visitId) {
        response = await api.getVisitPrescriptions(visitId);
      } else {
        response = await api.getPatientPrescriptions(patientId);
      }
      console.log(response.data);
      setPrescriptions(response.data.filter(p => p.status.value === 'active'));
    } catch (error) {
      console.error('Failed to load prescriptions:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Prescription (Optional)
      </label>
      
      {!selectedPrescription ? (
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowDropdown(!showDropdown)}
            disabled={!patientId || prescriptions.length === 0}
            className="w-full px-4 py-2 text-left border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            {!patientId ? (
              <span className="text-gray-400">Select a patient first</span>
            ) : prescriptions.length === 0 ? (
              console.log("llll"+prescriptions.length ),
              <span className="text-gray-400">No active prescriptions found</span>
            ) : (
              <span className="text-gray-700">Select a prescription...</span>
            )}
          </button>

          {showDropdown && prescriptions.length > 0 && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
              {prescriptions.map((prescription) => (
                <div
                  key={prescription.id}
                  className="p-3 hover:bg-blue-50 cursor-pointer border-b last:border-b-0"
                  onClick={() => {
                    onSelectPrescription(prescription);
                    setShowDropdown(false);
                  }}
                >
                  <div className="flex items-center space-x-3">
                    <div className="bg-green-100 p-2 rounded-full">
                      <FaPrescription className="text-green-600" />
                    </div>
                    <div className="flex-1">
                      <div className="font-medium text-gray-900">{prescription.prescription_number}</div>
                      <div className="flex items-center space-x-3 text-sm text-gray-500">
                        <span className="flex items-center">
                          <FaCalendar className="mr-1 h-3 w-3" />
                          {formatDate(prescription.summary.prescribed_on)}
                        </span>
                        <span className="flex items-center">
                          <FaUserMd className="mr-1 h-3 w-3" />
                          {prescription.summary.prescribed_by}
                        </span>
                      </div>
                      <div className="flex items-center mt-1 text-xs text-gray-400">
                        <FaPills className="mr-1 h-3 w-3" />
                        {prescription.items.length} medicine(s)
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-green-800">{selectedPrescription.prescription_number}</p>
              <p className="text-sm text-green-600">
                {formatDate(selectedPrescription.summary.prescribed_on)} • Dr. {selectedPrescription.summary.prescribed_by}
              </p>
              <p className="text-xs text-green-500 mt-1">
                {selectedPrescription.items.length} medicine(s) prescribed
              </p>
            </div>
            <button
              onClick={() => onSelectPrescription(null)}
              className="text-sm text-red-600 hover:text-red-800"
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrescriptionSelector;